<template>
  <el-dialog
    :visible.sync="dialog"
    width="950px"
    center
    :before-close="handleClose"
    :close-on-click-modal="false"
    custom-class="my-dialog"
  >
    <div class="pano-header">
      <span class="title" v-if="type==1">全景素材库</span>
      <span class="title" v-if="type==2">全景视频素材库</span>
      <span class="title" v-if="type==3">模型素材库</span>
      <span class="title" v-if="type==4">图片素材库</span>
      <span class="title" v-if="type==6">视频素材库</span>
      <div class="select">
        <el-input placeholder="请输入内容" v-model="searchTxt" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="upload-block">
        <upload :type="type" :func="uploadPic"></upload>
      </div>
    </div>
    <div class="pano-modal-body">
      <!-- <div class="title-line">
        <div class="title-line-left" @click="chooseAll">
          <div class="checkbox-block">
            <div :class="{'checkbox':true,'active':allcheck}">
              <i class="el-icon-check"></i>
            </div>
          </div>
          <div class="all-word">全选</div>
        </div>
      </div> -->
      <div class="list-header" v-show="type != 3">
        <div class="rootFolder" @click="backTop">
          根目录
        </div>
        <div v-show="nowFolderName!='根目录'">
          <span class="backFolder" @click="backFolder">返回上一级</span> <span>></span> <span v-html="nowFolderName"></span>
        </div>
      </div>
      <div class="list">
        <div class="list-li list-folder" v-for="(item) in folderArr" :key="item.id">
          <div class="imgBox" @click="changeFolder(item)">
            <img src="data:image/png;base64,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">
          </div>
          <div class="middle">
            <div class="li-title">
              <span class="li-title-span">{{item.name}}</span>
            </div>
          </div>
          <div class="date" style="margin-right: 10px">
            {{ item.createTime | dateFormat("YY-mm-dd HH:MM") }}
          </div>
        </div>
        <div class="list-li" v-for="(item,i) in arr" :key="i" @click="choose(item.id)">
          <div class="checkbox-block">
            <div :class="{'checkbox':true,'active':item.check}">
              <i class="el-icon-check"></i>
            </div>
          </div>
          <div class="middle">
            <div class="img-block">
              <img :src="item.thumbnailUrl" />
            </div>
            <div class="li-title">{{item.fileName}}</div>
          </div>

          <div class="date">{{item.createTime | dateFormat('YY-mm-dd HH:MM')}}</div>
        </div>
      </div>
      <div class="page-block">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="8"
          :current-page="page.currentPage"
          layout="total, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<style>
.my-dialog{
  z-index:10000;
  color: black;
}
.my-dialog.el-dialog--center .el-dialog__body {
  padding: 0 0 10px 0;
}

/* .my-dialog .el-dialog__header {
  padding: 0;
} */

.my-dialog .el-dialog__headerbtn {
  top: 7px;
  right: 7px;
  z-index: 10;
}
.el-pager .number{
 color: black;
}
</style>
<style scoped>
.pano-header {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 20px;
  font-size: 20px;
  border-bottom: 1px solid #e9e9e9;
}

.title {
  margin-right: 20px;
  font-size: 16px;
  font-weight: 700;
  color: black;
}

.select {
  flex: 1 auto;
}

.input-with-select {
  width: 200px;
}

.upload-block {
  font-size: 14px;
}

.pano-model-body {
  position: relative;
  flex: 1 auto;
}

.title-line {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  background-color: #f3f3f3;
  border-bottom: 1px solid #e9e9e9;
}

.title-line-left {
  display: flex;
  align-items: center;
}
.all-word {
  color: black;
}

.checkbox-block {
  margin-right: 10px;
}

.checkbox {
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  color: white!important;
}

.checkbox.active {
  background-color: #427afb;
  border-color: #427afb;
}

.list {
  height: 435px;
}
.list-header {
  height: 50px;
  width: 100%;
  background-color: #f8f8f8;
  display: flex;
}
.list-header div{
  height: 50px;
  line-height: 50px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
  color: black !important;
}
.list-header span{
  color: black !important;
}
.list-header .rootFolder:hover{
  color: #286efa !important;
}
.list-header .backFolder:hover{
  color: #286efa !important;
}
.list-folder .imgBox{
  margin-left: 24px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.list-folder {
  color: black !important;
}
.list-folder .li-title-span{
  color: black !important;
}
.list-folder .imgBox img{
  width: 30px;
  height: 30px;
}
.list-folder .date{
  margin-right: 0 !important;
}
.listIn .list-folder .imgBox{
  margin-left: 0;
}

.list-li {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid #e9e9e9;
}

.middle {
  display: flex;
  flex: 1 auto;
  align-items: center;
}

.img-block {
  width: 30px;
  height: 30px;
  background-color: #ddd;
  cursor: pointer;
}

.img-block img {
  width: 100%;
  height: 100%;
}

.li-title {
  max-width: 500px;

  margin-left: 10px;
  line-height: 30px;
  font-size: 12px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  color: black;
}

.date {
  font-size: 12px;
  color: #9b9b9b;
}

.page-block {
  display: flex;
  justify-content: center;
}
</style>
<script>
import https from '../https.js'
import Upload from '../components/upload.vue'
export default {
  name: '',
  props: {
    type: String,
    closeFunc: Function,
    submitFunc: Function
  },
  components: {
    Upload: Upload
  },

  data() {
    return {
      dialog: true,
      searchTxt: '',
      allcheck: false,
      page: {
        currentPage: 1,
        total: 0
      },
      chooseArr: [],
      nowFolderName: '根目录',
      nowFolderID: '',
      nowFolderPName: '',
      nowFolderPID: '',
      fileArr: [],
      folderArr: [],
      folderCurrentPage: 1,
      arr: [
        // {
        //   id: "44901c67-81c4-4f30-8fea-c1d0dfc1927b",
        //   fileName: "weixin_code.png",
        //   filePath: "/Attached/2020/6/17/weixin_code.png",
        //   fileFormat: ".png",
        //   hashValue: "2020617135921",
        //   fileSize: 11917,
        //   type: null,
        //   status: 1,
        //   createTime: "2020-06-17T13:59:21.487",
        //   thumbnailUrl: null
        // }
      ]
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    changeFolder(item) {
      this.nowFolderPName = this.nowFolderName
      this.nowFolderID = item.id
      this.nowFolderName = item.name
      this.nowFolderPID = item.parentID
      this.init()
    },
    backTop() {
      this.nowFolderName = '根目录'
      this.nowFolderID = ''
      this.init()
    },
    backFolder() {
      if(this.nowFolderPID == null) {
        this.nowFolderID = ''
        this.nowFolderName = '根目录'
        this.init()
      }else{
        https
          .fetchGet('/api/folder/Get', {
            FID: this.nowFolderPID
          })
          .then(res => {
            console.log(res.data)
            this.nowFolderName = res.data.result[0].name
            this.nowFolderID = res.data.result[0].id
            this.nowFolderPID = res.data.result[0].parentID
            this.init()
          })
      }
    },
    genFolderType() {
      switch(this.type) {
        case '1':
          return 3
        case '2':
          return 4
        case '3':
          return 6
        case '4':
          return 5
        case '6':
          return 7
        case '7':
          return 8
      }
    },
    init() {
      // https
      //   .fetchPost('/api/PhysicalFile/Get', {
      //     type: this.type,
      //     pageIndex: this.page.currentPage,
      //     pageSize: 8
      //   })
      //   .then(res => {
      //     console.log(res.data)
      //     this.page.total = res.data.count

      //     for (let i = 0; i < res.data.result.length; i++) {
      //       res.data.result[i].check = false
      //     }
      //     this.arr = res.data.result
      //   })
      https
        .fetchPost('/api/PhysicalFile/Get', {
          type: this.type,
          pageIndex: this.page.currentPage,
          fileName: this.searchTxt,
          pageSize: 8,
          folderID: this.nowFolderID,
          folderType: this.genFolderType()
        })
        .then((res) => {
          console.log(res)
          this.page.total = res.data.count
          for (let i = 0; i < res.data.result.length; i++) {
            res.data.result[i].check = false
          }
          this.arr = res.data.result
          this.folderArr = res.data.folders
          console.log(this.arr)
        })
    },
    handleCurrentChange(val) {
      this.allcheck = false
      this.chooseArr = []
      this.page.currentPage = val
      this.init()
    },
    chooseAll() {
      this.allcheck = !this.allcheck
      if (this.allcheck) {
        for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].check = true
        }
        this.chooseArr = this.arr
      } else {
        for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].check = false
        }
        this.chooseArr = []
      }
    },
    choose(id) {
      this.chooseArr = []
      for (let i = 0; i < this.arr.length; i++) {
        if (this.arr[i].id === id) {
          const isCheck = this.arr[i].check || false
          if (isCheck) {
            this.arr[i].check = false
          } else {
            console.log(isCheck)
            this.arr[i].check = true
            console.log(this.arr)
            this.chooseArr.push(this.arr[i])
          }
        } else {
          if (this.arr[i].check) {
            this.chooseArr.push(this.arr[i])
          }
        }
      }
      if (this.chooseArr.length === 8) {
        this.allcheck = true
      } else {
        this.allcheck = false
      }
    },
    handleClose(done) {
      this.closeFunc()
    },
    uploadPic(data) {
      console.log(data)
      this.init()
    },
    submit() {
      this.submitFunc(this.chooseArr)
      this.closeFunc()
    }
  }
}
</script>
